import React from "react";
import { Grid, Typography } from "@material-ui/core";
import PreviousTaxDocumentNew from "./PreviousTaxDocumentNew";
import PreviousTaxDocumentList from "./PreviousTaxDocumentsList";

//import { getTaxReturn } from "../graphql/queries";

export default function PreviousTaxDocumentsView(props) {
  console.log("Inside Previous Year TaxDocuments View:", props);
  return (
    <>
      <Grid
        container
        direction="row"
        spacing={1}
        justify="space-around"
        alignItems="center"
      >
        <Grid item xs={6}>
          <Typography variant="h6">Previous Year</Typography>
        </Grid>
        <Grid item xs={5}>
          <PreviousTaxDocumentNew />
        </Grid>
      </Grid>
      <Grid item xs={11}>
        <PreviousTaxDocumentList />
      </Grid>
    </>
  );

  /*return <div>{props.taxDocumentType}</div>*/
}
